import React, { PropsWithChildren } from 'react';

import { dustyOrangeTwo, lightRed, turquoise } from '~/styles';

import { LevelContainer, LevelName, LevelOneView, LevelThreeView, LevelTwoView } from './elements';

interface Props {
  id: string;
  name?: string;
}

type Config = { color: string; fill: number };
const configs: { [key: string]: undefined | Config } = {
  170: { color: turquoise, fill: 1 },
  171: { color: dustyOrangeTwo, fill: 2 },
  172: { color: lightRed, fill: 3 },
};

export const Intensity: React.FC<PropsWithChildren<Props>> = ({ id, name }) => {
  const config = configs[id];
  if (!config) return null;
  const { color, fill } = config;

  return (
    <div aria-label="class intensity indicator">
      <LevelContainer>
        <LevelOneView color={color} showFill />
        <LevelTwoView color={color} showFill={fill >= 2} />
        <LevelThreeView color={color} showFill={fill >= 3} />
      </LevelContainer>
      {name && <LevelName>{name}</LevelName>}
    </div>
  );
};
